import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Divider, Grid, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useEffect, useState } from "react";
import { countryRequest } from "../../../api/CountryRequest";

interface Props {
  open: boolean;
  onClose: AnyFunction;
  city?: City;
  onCityEdited: AnyFunction;
  selectedCountyId: number;
}

interface FormValues {
  name: string;
}

export default function EditCityDialog(props: Props) {
  const { open, onClose, city, onCityEdited, selectedCountyId } = props;
  const [formValues, setFormValues] = useState<FormValues>({
    name: "",
  });

  const [error, setError] = useState({
    name: false,
    nameIsDuplicate: false,
  });

  const [cityData, setCityData] = useState<City[]>([]);

  const fetchCities = () => {
    countryRequest
      .getCities(selectedCountyId)
      .then((cities) => setCityData(cities));
  };

  useEffect(() => {
    fetchCities();
  }, []);

  const checkNameIsDuplicate = (city: City) =>
    city.name?.toLowerCase() === formValues.name?.toLowerCase();

  const handleErrors = () => {
    if (!formValues.name) {
      setError((prev: any) => ({
        ...prev,
        name: true,
      }));
    } else if (formValues.name) {
      setError((prev: any) => ({
        ...prev,
        name: false,
      }));
    }
    if (formValues.name) {
      setError((prev: any) => ({
        ...prev,
        nameIsDuplicate: cityData.some(checkNameIsDuplicate),
      }));
    }
  };

  const handleSubmit = () => {
    if (city && city.id) {
      handleErrors();
      const nameCondition =
        formValues.name === city?.name || !cityData.some(checkNameIsDuplicate);
      const formIsValid = formValues.name && nameCondition;
      if (formIsValid) {
        return countryRequest
          .updateCity(city.id, formValues)
          .then(() => {
            if (typeof onCityEdited === "function") {
              onCityEdited();
            }
          })
          .catch(() => {
            alert("S-a produs o eroare!");
          });
      }
    }
  };

  const handleCloseAddCityDialog = () => {
    onClose();
    setError(() => ({
      name: false,
      nameIsDuplicate: false,
    }));
  };

  useEffect(() => {
    if (city && city.name) {
      setFormValues({ name: city.name });
    }
  }, [city]);

  return (
    <>
      <Dialog open={open} fullWidth maxWidth="xs">
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item>
            <DialogTitle sx={{ pb: 0 }}>Adăugare localitate</DialogTitle>
          </Grid>
          <Grid item sx={{ mr: 2, pt: 2 }}>
            <IconButton onClick={handleCloseAddCityDialog} tabIndex={-1}>
              <ClearIcon />
            </IconButton>
          </Grid>
        </Grid>
        <DialogContent>
          <TextField
            required
            label="Nume"
            size="small"
            fullWidth
            error={error.name || error.nameIsDuplicate}
            helperText={
              error.name
                ? "Câmp obligatoriu!"
                : error.nameIsDuplicate && "Nume deja existent!"
            }
            value={formValues?.name ?? ""}
            onChange={(event) =>
              setFormValues((prev: any) => ({
                ...prev,
                name: event.target.value.toUpperCase(),
              }))
            }
            onKeyUp={(e) => {
              if (e.key === "Enter") {
                handleSubmit()
                  ?.then(handleCloseAddCityDialog)
                  .then(fetchCities);
              }
            }}
            inputProps={{ style: { textTransform: "uppercase" } }}
          ></TextField>
          <Divider sx={{ mb: 2, opacity: 0 }} />
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
          >
            <Grid item xs={12} md={6}>
              <Button
                fullWidth
                variant="contained"
                onClick={() => {
                  handleSubmit()
                    ?.then(handleCloseAddCityDialog)
                    .then(fetchCities);
                }}
                disabled={!formValues.name}
              >
                Salvează
              </Button>
            </Grid>
            <Grid item xs={12} md={6}>
              <Button
                fullWidth
                variant="outlined"
                onClick={handleCloseAddCityDialog}
              >
                Renunță
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
}
